import { 
  dimensiondata_1_felhasznalasi_cel_group_row,
  dimensiondata_2_termekek_group_dimension_1_column,
  // dimensiondata_2_felhasznalasi_cel_group_dimension_1_column,
  // dimensiondata_1_termekek_group_w200_row,
  year_column_expanded,
  TJ_value_1_data_precision,
  order_1,
  order_2
} from '../../fields';
import { PivotGridConfig } from '../../utils/pivot-grid-config';

export const haztartasVegsoConfig: PivotGridConfig = {
  showChart: false,
  filterYear: {numberOfYears: 1},
  options: {
    store: {
      version: 4,
      type: 'odata',
      url: 'odata/v4/public/HaztartasVegso',
      select: ['date', 'dimension_1', 'dimension_2', 'value_1'],
      beforeSend: (e: any) => {
        e.headers = {
          Accept: 'application/json;odata.metadata=none',
        };
      },
    },
    retrieveFields: false,
    fields: [
      ...dimensiondata_1_felhasznalasi_cel_group_row,
      year_column_expanded,
      ...dimensiondata_2_termekek_group_dimension_1_column,
      TJ_value_1_data_precision,
      order_1,
      order_2
    ],
  },
};
